module.exports = __webpack_public_path__ + "img/slika-2.ef27071a.png";